// src/utils/telcPartPoints.js
//
// telc B1 and B2 points per part, as both Übungstests print them ("Punkte und
// Gewichtung"): every Teil is worth the same however many items it has, so
// Lesen Teil 1/2 give 5 points per item and Teil 3 2.5; Hören Teil 1/3 give 5
// and Teil 2 2.5; Sprachbausteine 1.5 each. Shared by the score (examService)
// and the results insights, so "points you can gain" always add up to the score.
export const TELC_PART_MAX = {
  'reading-part-1': 25, 'reading-part-2': 25, 'reading-part-3': 25,
  'grammar-part-1': 15, 'grammar-part-2': 15,
  'listening-part-1': 25, 'listening-part-2': 25, 'listening-part-3': 25,
};
